export const Separator = () => {
  return (
    <div
      style={{
        height: 1,
        width: '100%',
        backgroundColor: 'rgba(50,50,50,0.2)',
      }}
    />
  );
}